// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/fonts/NotoSansKR-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/fonts/NotoSansKR-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/fonts/NotoSansKR-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/fonts/NotoSansKR-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/src/fonts/NotoSansKR-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/src/fonts/NotoSansKR-Black.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/src/fonts/NotoSansKR-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/src/fonts/NotoSansKR-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/src/fonts/NotoSansKR-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("/src/fonts/NotoSansKR-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("/src/fonts/NotoSansKR-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("/src/fonts/NotoSansKR-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("/src/fonts/NotoSansKR-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("/src/fonts/NotoSansKR-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("/src/fonts/NotoSansKR-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("/src/fonts/NotoSansKR-Thin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("/src/fonts/NotoSansKR-Thin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("/src/fonts/NotoSansKR-Thin.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: 'NotoSansKR-Regular', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -ms-overflow-style: none;
}

code {
  font-family: 'NotoSansKR-Regular', source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

body::-webkit-scrollbar {
  display: none;
}

@font-face {
  font-family: 'NotoSansKR-Bold';
  src:
  url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
  url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
  url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('otf');
}
@font-face {
  font-family: 'NotoSansKR-Black';
  src:
  url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
  url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff'),
  url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('otf');
}
@font-face {
  font-family: 'NotoSansKR-Light';
  src:
  url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'),
  url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff'),
  url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('otf');
}
@font-face {
  font-family: 'NotoSansKR-Medium';
  src:
  url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff2'),
  url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff'),
  url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('otf');
}
@font-face {
  font-family: 'NotoSansKR-Regular';
  src:
  url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff2'),
  url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff'),
  url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('otf');
}
@font-face {
  font-family: 'NotoSansKR-Thin';
  src:
  url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('woff2'),
  url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('woff'),
  url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('otf');
}


/* Defualt Input CSS */
input:focus,
textarea:focus {
    box-shadow: none!important;
    outline: none;
}

button:focus {
  box-shadow: none!important;
}

input::placeholder,
input::-webkit-input-placeholder {
    color: #999999;
    font-size: 14px;
    font-family: NotoSansKR-Regula;
    line-height: 20px;
}

textarea {
    resize: none;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE;aACW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B;;;uDAGiD;AACnD;AACA;EACE,+BAA+B;EAC/B;;;uDAGkD;AACpD;AACA;EACE,+BAA+B;EAC/B;;;uDAGkD;AACpD;AACA;EACE,gCAAgC;EAChC;;;wDAGmD;AACrD;AACA;EACE,iCAAiC;EACjC;;;wDAGoD;AACtD;AACA;EACE,8BAA8B;EAC9B;;;wDAGiD;AACnD;;;AAGA,sBAAsB;AACtB;;IAEI,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB","sourcesContent":["body {\n  margin: 0;\n  font-family: 'NotoSansKR-Regular', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  -ms-overflow-style: none;\n}\n\ncode {\n  font-family: 'NotoSansKR-Regular', source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\nbody::-webkit-scrollbar {\n  display: none;\n}\n\n@font-face {\n  font-family: 'NotoSansKR-Bold';\n  src:\n  url(/src/fonts/NotoSansKR-Bold.woff2) format('woff2'),\n  url(/src/fonts/NotoSansKR-Bold.woff) format('woff'),\n  url(/src/fonts/NotoSansKR-Bold.otf) format('otf');\n}\n@font-face {\n  font-family: 'NotoSansKR-Black';\n  src:\n  url(/src/fonts/NotoSansKR-Black.woff2) format('woff'),\n  url(/src/fonts/NotoSansKR-Black.woff) format('woff'),\n  url(/src/fonts/NotoSansKR-Black.otf) format('otf');\n}\n@font-face {\n  font-family: 'NotoSansKR-Light';\n  src:\n  url(/src/fonts/NotoSansKR-Light.woff2) format('woff2'),\n  url(/src/fonts/NotoSansKR-Light.woff) format('woff'),\n  url(/src/fonts/NotoSansKR-Light.otf) format('otf');\n}\n@font-face {\n  font-family: 'NotoSansKR-Medium';\n  src:\n  url(/src/fonts/NotoSansKR-Medium.woff2) format('woff2'),\n  url(/src/fonts/NotoSansKR-Medium.woff) format('woff'),\n  url(/src/fonts/NotoSansKR-Medium.otf) format('otf');\n}\n@font-face {\n  font-family: 'NotoSansKR-Regular';\n  src:\n  url(/src/fonts/NotoSansKR-Regular.woff2) format('woff2'),\n  url(/src/fonts/NotoSansKR-Regular.woff) format('woff'),\n  url(/src/fonts/NotoSansKR-Regular.otf) format('otf');\n}\n@font-face {\n  font-family: 'NotoSansKR-Thin';\n  src:\n  url(/src/fonts/NotoSansKR-Thin.woff2) format('woff2'),\n  url(/src/fonts/NotoSansKR-Thin.woff) format('woff'),\n  url(/src/fonts/NotoSansKR-Thin.otf) format('otf');\n}\n\n\n/* Defualt Input CSS */\ninput:focus,\ntextarea:focus {\n    box-shadow: none!important;\n    outline: none;\n}\n\nbutton:focus {\n  box-shadow: none!important;\n}\n\ninput::placeholder,\ninput::-webkit-input-placeholder {\n    color: #999999;\n    font-size: 14px;\n    font-family: NotoSansKR-Regula;\n    line-height: 20px;\n}\n\ntextarea {\n    resize: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
